import { c as _c } from "react/compiler-runtime";
import { Card } from '@xefi/x-react/card';
import { Skeleton } from '@xefi/x-react/skeleton';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import { type ReactNode, useEffect, useState } from 'react';
import { FilePreview } from '@/components/FilePreview';
import { PreviewModal } from '@/components/PreviewModal';
import { renderFileSize } from '@/utils/files';
import { FileIcon } from './FileIcon';
import type { File as CustomFile, Preview } from './types';
type FileCardProps = {
  file: CustomFile;
  onClickAction?: 'preview' | 'download';
  isFitContent?: boolean;
  children?: ReactNode;
  isLoading?: boolean;
};
export const FileCard = t0 => {
  const $ = _c(36);
  const {
    file,
    onClickAction: t1,
    isFitContent,
    children,
    isLoading: t2
  } = t0;
  const onClickAction = t1 === undefined ? "preview" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const [showContent, setShowContent] = useState(false);
  const isPreviewAction = onClickAction === "preview";
  let t3;
  if ($[0] !== file.data || $[1] !== file.name || $[2] !== file.type) {
    t3 = () => {
      if (!file.data) {
        return;
      }
      const linkSource = `data:${file.type};base64,${file.data}`;
      const link = document.createElement("a");
      link.setAttribute("href", linkSource);
      link.setAttribute("download", file.name);
      document.body.appendChild(link);
      link.click();
      link.remove();
    };
    $[0] = file.data;
    $[1] = file.name;
    $[2] = file.type;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const downloadFile = t3;
  let t4;
  let t5;
  if ($[4] !== isLoading) {
    t4 = () => {
      if (!isLoading) {
        const timer = setTimeout(() => setShowContent(true), 50);
        return () => clearTimeout(timer);
      } else {
        setShowContent(false);
      }
    };
    t5 = [isLoading];
    $[4] = isLoading;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  const t6 = onClickAction === "download";
  const t7 = isFitContent && "w-fit";
  let t8;
  if ($[7] !== t7) {
    t8 = mergeTailwindClasses("p-0", t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = onClickAction === "download" && "cursor-pointer";
  let t10;
  if ($[9] !== t9) {
    t10 = mergeTailwindClasses("flex-row justify-between", t9);
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t8) {
    t11 = {
      base: t8,
      body: t10
    };
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== downloadFile || $[15] !== onClickAction) {
    t12 = () => {
      if (onClickAction === "download") {
        downloadFile();
      }
    };
    $[14] = downloadFile;
    $[15] = onClickAction;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `flex items-start gap-2 transition-opacity duration-300 ${isLoading ? "opacity-100" : showContent ? "opacity-100" : "opacity-0"}`;
  let t14;
  if ($[17] !== downloadFile || $[18] !== file || $[19] !== isLoading || $[20] !== isPreviewAction) {
    t14 = <div className="flex size-[18px] shrink-0 items-center justify-center">{isLoading ? <Skeleton className="size-[18px] rounded" /> : isPreviewAction ? <PreviewModal trigger={<FileIcon type={file.type} />}><FilePreview preview={file as Preview} /></PreviewModal> : <button onClick={downloadFile}><FileIcon type={file.type} /></button>}</div>;
    $[17] = downloadFile;
    $[18] = file;
    $[19] = isLoading;
    $[20] = isPreviewAction;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== file.name || $[23] !== file.size || $[24] !== isLoading) {
    t15 = <div className="flex-1"><div className="flex min-h-[20px] items-baseline gap-2">{isLoading ? <><Skeleton className="h-[14px] w-32" /><Skeleton className="h-[12px] w-12" /></> : <div className="flex items-baseline gap-2"><span className="text-sm opacity-60">{file.name}</span>{file.size !== undefined && <span className="text-xs opacity-40">{renderFileSize(file.size)}</span>}</div>}</div></div>;
    $[22] = file.name;
    $[23] = file.size;
    $[24] = isLoading;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t15) {
    t16 = <div className={t13}>{t14}{t15}</div>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== children || $[31] !== t11 || $[32] !== t12 || $[33] !== t16 || $[34] !== t6) {
    t17 = <Card radius="lg" shadow="sm" isPressable={t6} classNames={t11} onClick={t12}>{t16}{children}</Card>;
    $[30] = children;
    $[31] = t11;
    $[32] = t12;
    $[33] = t16;
    $[34] = t6;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
};